import React, { useEffect, useState } from "react";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextField from "@mui/material/TextField";
import blogFetch from "../../../axios/config";
import { getIdCompany } from "../../../utils/constantes";
import { IBlock, IAddBlock } from "./BlocInterfaces";
const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props: any, ref) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [bloc, setBloc] = useState<IBlock>({
    blC_active: true,
    blC_description: "",
    blC_FK_companyId: 0,
    blC_PK_idBLoc: 0,
  });

  useEffect(() => {
    getBloc();
  }, []);

  useImperativeHandle(ref, () => ({
    addBloc,
    updateBloc,
  }));

  const getBloc = async () => {
    if (props.idBloc != null) {
      setLoading(true);
      try {
        let response = await blogFetch.get(`/bloc/${props.idBloc}`);
        let data = response.data;
        setTimeout(() => {
          setBloc(data);
          setLoading(false);
        }, 300);

        return data;
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  };
  const addBloc = async () => {
    const addBlocs: IAddBlock = {
      blC_PK_idBLoc: 0,
      blC_description: bloc.blC_description,
      blC_active: true,
      blC_FK_companyId: getIdCompany(),
    };
    try {
      const response = await blogFetch.post("/bloc", addBlocs);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const updateBloc = async () => {
    try {
      const response = await blogFetch.put("/bloc/" + props.idBloc, bloc);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return (
    <>
      {loading ? (
        <center>
          <div className="loading-container">
            <FontAwesomeIcon icon={faSpinner} spin />
          </div>
        </center>
      ) : (
        <div className="mb-3">
          <TextField
            required
            id="outlined-basic"
            label="Nome do Bloco"
            variant="outlined"
            fullWidth
            value={bloc.blC_description}
            onChange={(e) =>
              setBloc({ ...bloc, blC_description: e.target.value })
            }
          />
        </div>
      )}
    </>
  );
});
